import React from 'react';
import "./side-container.css";

const SideContainer = (
  {
    children
  }
) => {
  return (
    <div
      style={{
        position: 'fixed',
        minHeight: '500px',
        maxHeight: 'calc(100vh - 70px)',
        overflow: 'auto'
      }}
      className="side_container shadow"
    >
      { children }
    </div>
  )
};

export default SideContainer;


// WEBPACK FOOTER //
// ./src/components/side-container/side-container-component.js